import { useContext } from 'react'

import AppContext from '@/common/context/app.context'
import useStoreProductCategories from '@/common/hooks/useStoreProductCategories/useStoreProductCategories'
import useStoreProductCollections from '@/common/hooks/useStoreProductCollections/useStoreProductCollections'
import { blockSettingOptionsSources } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/constants'

import { mapProductOption } from './helpers'

const useBlockSettingOptions = ({ field }) => {
  const { info } = useContext(AppContext)

  const storeId = info?.selectedStore?.id

  const { productCategories, fetchingProductCategories } = useStoreProductCategories({
    storeId,
    doInitialRequest: field.optionsSource === blockSettingOptionsSources.productCategories,
  })

  const { productCollections, fetchingProductCollections } = useStoreProductCollections({
    storeId,
    doInitialRequest: field.optionsSource === blockSettingOptionsSources.productCollections,
  })

  if (field.options) return { options: field.options, loadingOptions: false }

  if (field.optionsSource === blockSettingOptionsSources.productCategories) {
    return { options: productCategories.map(mapProductOption), loadingOptions: fetchingProductCategories }
  }

  if (field.optionsSource === blockSettingOptionsSources.productCollections) {
    return { options: productCollections.map(mapProductOption), loadingOptions: fetchingProductCollections }
  }

  return { options: [], loadingOptions: false }
}

export default useBlockSettingOptions
